import { gql } from "@apollo/client";

export const BULK_DELETE_INVOICES = gql`
  mutation bulkDeleteInvoices($input: BulkDeleteInvoicesInput!) {
    invoice {
      bulkDeleteInvoices(input: $input) {
        invoiceId
        errorMessage
        success
      }
    }
  }
`;
